{
  "admission": "Rawat Inap",
  "transfer": "Pindah Ruangan",
  "visit": "Kunjungan",
  "type": "Jenis Kunjungan",
  "status": "Status",
  "location": "Lokasi",
  "attendingPhysician": "Dokter Penanggung Jawab",
  "admitDate": "Tanggal Masuk",
  "dischargeDate": "Tanggal Pulang",
  "chiefComplaint": "Keluhan Utama",
  "diagnosis": "Diagnosis",
  "class": {
    "label": "Kelas",
    "values": {
      "emergency": "Gawat Darurat",
      "inpatient": "Rawat Inap",
      "outpatient": "Rawat Jalan",
      "observation": "Observasi",
      "ambulatory": "Rawat Sehari",
      "homeHealth": "Perawatan di Rumah",
      "virtual": "Telekonsultasi"
    }
  },
  "statusValues": {
    "label": "Status",
    "values": {
      "pending": "Menunggu",
      "arrived": "Sudah Tiba",
      "active": "Berlangsung",
      "completed": "Selesai",
      "cancelled": "Dibatalkan"
    }
  },
  "admissionSource": {
    "label": "Sumber Penerimaan",
    "none": "—",
    "values": {
      "emergency": "Instalasi Gawat Darurat",
      "clinicReferral": "Rujukan Poliklinik",
      "physicianReferral": "Rujukan Dokter",
      "transfer": "Pindah dari Fasilitas Lain",
      "self": "Datang Sendiri / Jalan Kaki",
      "courtLaw": "Pengadilan / Penegak Hukum"
    }
  },
  "admissionType": {
    "label": "Jenis Penerimaan",
    "none": "—",
    "values": {
      "elective": "Elektif",
      "emergency": "Gawat Darurat",
      "urgent": "Mendesak",
      "newborn": "Bayi Baru Lahir",
      "trauma": "Trauma"
    }
  },
  "acuity": {
    "label": "Tingkat Kegawatan",
    "none": "—",
    "values": {
      "1": "1 — Resusitasi",
      "2": "2 — Gawat",
      "3": "3 — Mendesak",
      "4": "4 — Kurang Mendesak",
      "5": "5 — Tidak Mendesak"
    },
    "shortValues": {
      "1": "Resusitasi",
      "2": "Gawat",
      "3": "Mendesak",
      "4": "Kurang Mendesak",
      "5": "Tidak Mendesak"
    },
    "esiBadge": "ESI {{level}} - {{label}}"
  },
  "form": {
    "title": "Kunjungan Baru",
    "subtitle": "Mulai kunjungan / penerimaan baru untuk pasien ini.",
    "sections": {
      "visit": "Informasi Kunjungan",
      "reasonForVisit": "Alasan Kunjungan",
      "admission": "Informasi Penerimaan"
    },
    "fields": {
      "facility": "Fasilitas",
      "encounterClass": "Kelas Kunjungan",
      "encounterType": "Jenis Kunjungan",
      "department": "Departemen",
      "attendingProvider": "Dokter Penanggung Jawab",
      "acuity": "Tingkat Kegawatan",
      "visitReason": "Alasan Kunjungan",
      "chiefComplaint": "Keluhan Utama",
      "admissionSource": "Sumber Penerimaan",
      "admissionType": "Jenis Penerimaan"
    },
    "placeholders": {
      "selectFacility": "Pilih fasilitas",
      "none": "—",
      "encounterType": "Mis. Pemeriksaan Tahunan, Kunjungan IGD",
      "visitReason": "Label singkat, mis. Kontrol Ulang, Pemeriksaan Tahunan",
      "chiefComplaint": "Alasan yang dinyatakan pasien dengan kata-katanya sendiri"
    },
    "providerFallback": "Dokter #{{id}}",
    "submit": "Buat Kunjungan",
    "validation": {
      "facilityRequired": "Fasilitas wajib dipilih",
      "encounterClassRequired": "Kelas kunjungan wajib dipilih"
    },
    "createdSuccess": "Kunjungan dibuat",
    "createError": "Gagal membuat kunjungan"
  },
  "detail": {
    "loading": "Memuat kunjungan...",
    "notFound": "Kunjungan tidak ditemukan",
    "loadError": "Gagal memuat kunjungan",
    "retry": "Coba lagi",
    "returnToDashboard": "Kembali ke Dasbor",
    "header": {
      "title": "Kunjungan {{number}}",
      "facilityLabel": "Fasilitas #{{id}}",
      "departmentLabel": "Departemen #{{id}}",
      "locationLabel": "Lokasi #{{id}}",
      "admittedLabel": "Masuk: {{datetime}}"
    },
    "actions": {
      "transfer": "Pindah Ruangan",
      "discharge": "Pulang"
    },
    "tabs": {
      "overview": "Ringkasan",
      "orders": "Order",
      "results": "Hasil",
      "medications": "Obat",
      "notes": "Catatan",
      "billing": "Tagihan"
    },
    "overview": {
      "chiefComplaint": "Keluhan Utama",
      "visitReason": "Alasan Kunjungan",
      "attendingProvider": "Dokter Penanggung Jawab",
      "acuityLevel": "Tingkat Kegawatan",
      "providerFallback": "Dokter #{{id}}",
      "empty": "--"
    },
    "timeline": {
      "title": "Linimasa Peristiwa",
      "empty": "Belum ada peristiwa tercatat",
      "admittedTitle": "Masuk",
      "admittedDescription": "{{class}} - {{chiefComplaint}}",
      "noChiefComplaint": "Tidak ada keluhan utama",
      "orderTitle": "Order: {{name}}",
      "orderDescription": "{{type}} - {{priority}} - {{status}}",
      "resultTitle": "Hasil: {{type}}"
    },
    "orders": {
      "title": "Order",
      "newOrder": "+ Order Baru",
      "empty": "Belum ada order untuk kunjungan ini",
      "metaLine": "{{number}} | {{type}} | Prioritas: {{priority}}"
    },
    "results": {
      "title": "Hasil",
      "empty": "Belum ada hasil untuk kunjungan ini",
      "criticalBadge": "KRITIS",
      "viewLink": "Lihat",
      "metaLine": "{{number}} | {{status}}"
    },
    "medications": {
      "title": "Obat",
      "newMedication": "+ Obat Baru",
      "empty": "Belum ada obat untuk kunjungan ini",
      "prnBadge": "PRN",
      "prnWithIndication": "PRN: {{indication}}"
    },
    "notes": {
      "comingSoon": "Modul catatan klinis segera hadir",
      "goToClinicalNotes": "Ke Catatan Klinis"
    },
    "billing": {
      "comingSoon": "Modul tagihan segera hadir"
    }
  },
  "census": {
    "title": "Papan Tempat Tidur / Sensus",
    "subtitle": "Okupansi tempat tidur dan sensus pasien secara real-time",
    "refresh": "Muat Ulang",
    "facilityName": "Rumah Sakit Umum Singapura",
    "capacitySummary": "{{occupied}} terpakai / {{total}} total tempat tidur",
    "occupancyLabel": "{{percent}}% okupansi",
    "stats": {
      "totalCapacity": "Total Kapasitas",
      "occupied": "Terpakai",
      "available": "Tersedia",
      "pendingDischarge": "Menunggu Pulang"
    },
    "unitFilter": {
      "all": "Semua Unit",
      "er": "ER",
      "icu": "ICU",
      "medsurg": "Penyakit Dalam/Bedah",
      "obs": "Observasi",
      "peds": "Pediatri",
      "maternity": "Maternitas"
    },
    "roleView": {
      "nurse": "Tampilan Perawat",
      "physician": "Tampilan Dokter",
      "bedManager": "Tampilan Manajer Tempat Tidur"
    },
    "viewMode": {
      "grid": "Tampilan Kisi",
      "table": "Tampilan Tabel"
    },
    "loading": "Memuat data sensus...",
    "columns": {
      "patient": "Pasien",
      "mrn": "MRN",
      "admitDate": "Tanggal Masuk",
      "status": "Status",
      "acuity": "Tingkat Kegawatan",
      "isolation": "Isolasi",
      "fallRisk": "Risiko Jatuh",
      "codeStatus": "Status Kode Resusitasi",
      "chiefComplaint": "Keluhan Utama",
      "attending": "Penanggung Jawab",
      "los": "LOS",
      "locationBed": "Lokasi / Tempat Tidur",
      "transferStatus": "Status Pindah",
      "expectedDischarge": "Perkiraan Pulang",
      "actions": "Tindakan"
    },
    "values": {
      "unknownPatient": "Tidak Diketahui",
      "none": "Tidak Ada",
      "notAvailable": "N/A",
      "pending": "Menunggu",
      "empty": "--",
      "providerFallback": "Dokter #{{id}}",
      "locationLabel": "Lokasi #{{id}}",
      "losDays": "{{days}} hari"
    },
    "codeStatusTooltip": "Status kode resusitasi tersedia di rekam medis pasien",
    "actionsMenu": {
      "label": "Tindakan",
      "viewChart": "Lihat Rekam Medis",
      "transfer": "Pindah Ruangan",
      "assignAttending": "Tetapkan Dokter Penanggung Jawab",
      "discharge": "Pulang"
    },
    "empty": "Tidak ada kunjungan aktif",
    "department": {
      "filteredTo": "Hanya menampilkan {{name}}",
      "idLabel": "Departemen {{id}}",
      "showAll": "Tampilkan semua departemen"
    },
    "facility": {
      "label": "Fasilitas",
      "allFacilities": "Semua Fasilitas",
      "idLabel": "Fasilitas {{id}}"
    }
  },
  "discharge": {
    "label": "Pulang",
    "title": "Alur Pemulangan",
    "encounterLabel": "Kunjungan {{number}}",
    "printButton": "Cetak Pemulangan",
    "loading": "Memuat kunjungan...",
    "notFound": "Kunjungan tidak ditemukan",
    "returnToDashboard": "Kembali ke Dasbor",
    "notActive": "Kunjungan ini tidak aktif (status: {{status}})",
    "backToEncounter": "Kembali ke Kunjungan",
    "progress": {
      "requiredMissingTooltip": "Bidang wajib belum diisi",
      "tasksRemainingTooltip": "Masih ada tugas yang tersisa"
    },
    "steps": {
      "summary": "Ringkasan Pemulangan",
      "medications": "Obat",
      "followup": "Kontrol Lanjutan",
      "instructions": "Instruksi",
      "nursing": "Tugas Keperawatan",
      "signoff": "Tanda Tangan DPJP",
      "review": "Tinjau & Konfirmasi"
    },
    "summary": {
      "title": "Ringkasan Pemulangan",
      "diagnosisLabel": "Diagnosis Pemulangan *",
      "diagnosisPlaceholder": "Masukkan diagnosis pemulangan...",
      "diagnosisCodeLabel": "Kode Diagnosis Pemulangan (ICD-10)",
      "diagnosisCodePlaceholder": "Cari kode ICD-10...",
      "proceduresLabel": "Tindakan yang Dilakukan",
      "proceduresPlaceholder": "Daftar tindakan yang dilakukan selama kunjungan ini...",
      "conditionLabel": "Kondisi saat Pulang *"
    },
    "condition": {
      "values": {
        "stable": "Stabil",
        "improved": "Membaik",
        "unchanged": "Tidak Berubah",
        "worsened": "Memburuk",
        "critical": "Kritis"
      }
    },
    "medications": {
      "title": "Obat Pemulangan",
      "instructions": "Tinjau setiap obat dan pilih lanjutkan, hentikan, atau ubah saat pemulangan.",
      "actions": {
        "continue": "Lanjutkan",
        "stop": "Hentikan",
        "modify": "Ubah"
      },
      "modifiedPlaceholder": "Masukkan instruksi yang diubah...",
      "empty": "Tidak ada obat aktif untuk kunjungan ini"
    },
    "medAction": {
      "values": {
        "continue": "lanjutkan",
        "stop": "hentikan",
        "modify": "ubah"
      }
    },
    "followup": {
      "title": "Janji Kontrol Lanjutan",
      "providerLabel": "Dokter Kontrol",
      "providerPlaceholder": "Nama dokter atau spesialisasi...",
      "dateLabel": "Tanggal Kontrol",
      "notesLabel": "Catatan Tambahan",
      "notesPlaceholder": "Catatan tambahan untuk kontrol lanjutan..."
    },
    "instructions": {
      "title": "Instruksi untuk Pasien",
      "generalLabel": "Instruksi Umum",
      "generalPlaceholder": "Instruksi pemulangan umum untuk pasien...",
      "dietaryLabel": "Instruksi Diet",
      "dietaryPlaceholder": "Pantangan atau anjuran diet...",
      "activityLabel": "Pembatasan Aktivitas",
      "activityPlaceholder": "Pembatasan aktivitas fisik...",
      "warningSignsLabel": "Tanda Bahaya yang Perlu Diwaspadai",
      "warningSignsPlaceholder": "Gejala yang membuat pasien harus kembali atau mencari pertolongan..."
    },
    "nursing": {
      "title": "Tugas Keperawatan",
      "instructions": "Lengkapi daftar berikut sebelum pemulangan. Tugas ini hanya bersifat catatan dan tidak memanggil API.",
      "tasks": {
        "removeIv": "Cabut akses IV",
        "discontinueMonitoring": "Lepas alat pemantauan",
        "patientEducation": "Edukasi pasien selesai",
        "medsReviewed": "Obat pemulangan telah ditinjau bersama pasien",
        "belongingsReturned": "Barang pribadi telah dikembalikan",
        "transportArranged": "Transportasi telah diatur"
      }
    },
    "signoff": {
      "title": "Tanda Tangan DPJP",
      "instructions": "Tinjau ringkasan pemulangan di bawah dan minta tanda tangan DPJP.",
      "diagnosisHeading": "Diagnosis Pemulangan",
      "notProvided": "Belum diisi",
      "medicationsHeading": "Obat Pemulangan",
      "noMedications": "Tidak ada obat untuk direkonsiliasi",
      "signedCompleted": "Tanda tangan DPJP selesai.",
      "signAsAttending": "Tanda Tangani sebagai DPJP",
      "requiresAttendingSignoff": "Membutuhkan tanda tangan DPJP"
    },
    "review": {
      "title": "Tinjau & Konfirmasi Pemulangan",
      "summaryHeading": "Ringkasan Pemulangan",
      "fields": {
        "diagnosis": "Diagnosis:",
        "procedures": "Tindakan:",
        "condition": "Kondisi:",
        "provider": "Dokter:",
        "date": "Tanggal:",
        "notes": "Catatan:",
        "general": "Umum:",
        "diet": "Diet:",
        "activity": "Aktivitas:",
        "warningSigns": "Tanda Bahaya:"
      },
      "medicationsHeading": "Rekonsiliasi Obat",
      "noMedications": "Tidak ada obat untuk direkonsiliasi",
      "followupHeading": "Kontrol Lanjutan",
      "instructionsHeading": "Instruksi untuk Pasien",
      "noInstructions": "Instruksi belum diisi",
      "pendingOrdersWarning": "Mungkin masih ada perintah yang belum selesai atau catatan yang belum ditandatangani. Periksa sebelum menyelesaikan pemulangan.",
      "diagnosisRequired": "Diagnosis pemulangan diperlukan sebelum menyelesaikan pemulangan.",
      "empty": "--"
    },
    "nav": {
      "previous": "Sebelumnya",
      "next": "Berikutnya",
      "complete": "Selesaikan Pemulangan"
    },
    "toast": {
      "success": "Pasien berhasil dipulangkan",
      "error": "Gagal menyelesaikan pemulangan"
    }
  },
  "components": {
    "transferDialog": {
      "title": "Pindahkan Kunjungan",
      "description": "Pindahkan pasien ke lokasi lain di dalam fasilitas.",
      "targetLocationLabel": "Lokasi Tujuan",
      "loadingLocations": "Memuat lokasi…",
      "selectLocation": "Pilih lokasi",
      "emptyState": "Tidak ada lokasi aktif lain di fasilitas ini.",
      "reasonLabel": "Alasan",
      "reasonPlaceholder": "mis. perlu isolasi, turun tingkat ICU, ranjang pengawasan lebih ketat",
      "actions": {
        "transfer": "Pindahkan"
      },
      "toasts": {
        "success": "Kunjungan telah dipindahkan",
        "error": "Gagal memindahkan kunjungan"
      }
    },
    "assignAttendingDialog": {
      "title": "Tetapkan Dokter Penanggung Jawab",
      "description": "Tetapkan dokter penanggung jawab untuk kunjungan ini.",
      "providerLabel": "Dokter Penanggung Jawab",
      "loadingProviders": "Memuat dokter…",
      "selectProvider": "Pilih dokter",
      "emptyState": "Tidak ada dokter aktif di fasilitas ini.",
      "actions": {
        "assign": "Tetapkan"
      },
      "toasts": {
        "success": "Dokter penanggung jawab ditetapkan",
        "error": "Tidak dapat menetapkan dokter penanggung jawab"
      }
    },
    "bedBoard": {
      "bedStatus": {
        "available": "Tersedia",
        "occupied": "Terisi",
        "reserved": "Tertahan",
        "cleaning": "Dibersihkan",
        "closed": "Ditutup",
        "isolated": "Isolasi",
        "contaminated": "Terkontaminasi"
      },
      "acuityLegendLabel": "Akuitas ESI:",
      "empty": "Tidak ada unit yang dikonfigurasi",
      "summary": {
        "available_one": "{{count}} tersedia",
        "available_other": "{{count}} tersedia",
        "occupied_one": "{{count}} terisi",
        "occupied_other": "{{count}} terisi",
        "reserved_one": "{{count}} tertahan",
        "reserved_other": "{{count}} tertahan",
        "cleaning_one": "{{count}} dibersihkan",
        "cleaning_other": "{{count}} dibersihkan",
        "closed_one": "{{count}} ditutup",
        "closed_other": "{{count}} ditutup",
        "isolated_one": "{{count}} isolasi",
        "isolated_other": "{{count}} isolasi",
        "contaminated_one": "{{count}} terkontaminasi",
        "contaminated_other": "{{count}} terkontaminasi"
      }
    },
    "protocolPanel": {
      "title": "Pendaftaran Protokol",
      "enroll": "Daftar",
      "availableProtocols": "Protokol Tersedia",
      "loadingProtocols": "Memuat protokol...",
      "noProtocols": "Tidak ada protokol tersedia",
      "stepBadge": "Langkah {{current}}/{{total}}",
      "loadingEnrollments": "Memuat pendaftaran...",
      "noEnrollments": "Tidak ada pendaftaran protokol aktif",
      "completeStep": "Selesaikan Langkah",
      "toasts": {
        "enrollSuccess": "Terdaftar dalam protokol",
        "enrollError": "Gagal mendaftar protokol",
        "advanceSuccess": "Langkah selesai",
        "advanceError": "Gagal melanjutkan langkah"
      }
    }
  }
}
